import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { SecurityStorage } from '../storage/security.storage';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
    private readonly securityStorageService = inject(SecurityStorage);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!environment.useAirlock) {
            const userInfo = this.securityStorageService.getUserInfo();
            const urlParams = new URLSearchParams(window.location.search);
            const token = userInfo?.token ?? urlParams.get('api_key');

            if (!!token) {
                const authRequest = request.clone({
                    headers: request.headers.set('Authorization', `Bearer ${token}`)
                });
                return next.handle(authRequest);
            }

            return next.handle(request);
        }

        const authRequest = request.clone({ withCredentials: true });
        return next.handle(authRequest);
    }
}
